/*
 * @Description: 
 * @Author: ywj
 * @Date: 2024-01-25 15:32:29
 * @LastEditTime: 2024-01-25 15:50:17
 * @LastEditors: ywj@originqc.com
 */
import { createSlice  } from "@reduxjs/toolkit";


interface ITopoState { 
 
  topoSelectNameArr:[]
}

const initialState = {
 
  topoSelectNameArr:[]
} as ITopoState
export const topoSelectNameSlice = createSlice({
  name:'topoSelectNameArr',
  initialState,
  reducers: {
   
    setSelectNameArr: (state: any, action: any) => { 
      state.topoSelectNameArr = action.payload;
      // return {...state};
    }
  }
})


export const { setSelectNameArr } = topoSelectNameSlice.actions;
export default topoSelectNameSlice.reducer;